/**
 * @deprecated
 * Includes are deprecated. See IMP-1330
 */
export enum USER_INCLUDES {
  ORGANIZATION = "organization",
  ROLES = "roles",
}
